import { featuresData } from '@/mocks/home';

const iconColors = [
  { bg: 'bg-primary-50', text: 'text-primary-600', groupHoverBg: 'group-hover:bg-primary-100' },
  { bg: 'bg-accent-50', text: 'text-accent-600', groupHoverBg: 'group-hover:bg-accent-100' },
  { bg: 'bg-secondary-50', text: 'text-secondary-600', groupHoverBg: 'group-hover:bg-secondary-100' },
  { bg: 'bg-primary-50', text: 'text-primary-600', groupHoverBg: 'group-hover:bg-primary-100' },
  { bg: 'bg-accent-50', text: 'text-accent-600', groupHoverBg: 'group-hover:bg-accent-100' },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full px-4 md:px-6 lg:px-10 py-10 md:py-14">
      <div className="w-full">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-1.5 h-7 rounded-full bg-secondary-500" />
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950">平台特色</h2>
          </div>
          <span className="text-xs text-foreground-500 hidden sm:block">5大核心优势 · 值得信赖</span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {featuresData.map((item, index) => {
            const color = iconColors[index] || iconColors[0];
            return (
              <div
                key={index}
                className="group rounded-xl border border-background-200/70 bg-background-50 p-5 md:p-6 hover:border-primary-200 transition-all text-center"
              >
                <div className={`w-14 h-14 mx-auto rounded-xl ${color.bg} flex items-center justify-center mb-4 ${color.groupHoverBg} transition-colors`}>
                  <div className={`w-6 h-6 flex items-center justify-center ${color.text}`}>
                    <i className={`${item.icon} text-xl`} />
                  </div>
                </div>
                <h3 className="text-base font-semibold text-foreground-950 mb-2.5">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}